import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="404 - Siden blev ikke fundet | Djurs Massage"
        description="Den side du leder efter findes desværre ikke. Se vores behandlinger, priser eller kontakt Djurs Massage i Ryomgård."
      />

      <div className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl text-center space-y-6 bg-white p-8 sm:p-12 rounded-3xl border border-[#E8E1D5] shadow-xs">
          <div className="w-16 h-16 rounded-2xl bg-[#F3F4F6] text-[#1E3A5F] border border-[#E8E1D5] flex items-center justify-center mx-auto text-2xl">
            <i className="fa-solid fa-compass" aria-hidden="true" />
          </div>

          <div>
            <span className="text-xs uppercase tracking-wider font-semibold text-[#C9A770]">Fejlkode 404</span>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1E3A5F] font-serif mt-1">
              Siden blev ikke fundet
            </h1>
            <p className="text-slate-600 text-sm sm:text-base mt-3 leading-relaxed">
              Vi beklager, men den side du leder efter, ser ud til at være flyttet eller findes ikke længere. Du kan bruge genvejene herunder til at finde det, du søger.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
            <Link
              to="/"
              className="flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#1E3A5F] hover:bg-[#162F4D] text-white text-xs font-semibold transition-colors shadow"
            >
              <i className="fa-solid fa-house text-[#C9A770]" aria-hidden="true" />
              <span>Gå til startsiden</span>
            </Link>
            <Link
              to="/behandlinger"
              className="flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#F3F4F6] hover:bg-[#F2ECE3] text-[#1E3A5F] text-xs font-semibold border border-[#D8CDBE] transition-colors"
            >
              <i className="fa-solid fa-hands text-[#C9A770]" aria-hidden="true" />
              <span>Se behandlinger</span>
            </Link>
          </div>

          <div className="pt-4 border-t border-[#F2ECE3] text-xs text-slate-500">
            Har du spørgsmål? Ring til os direkte på{' '}
            <a href="tel:28583907" className="font-semibold text-[#1E3A5F] underline whitespace-nowrap">
              28 58 39 07
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
